// extracted by mini-css-extract-plugin
export default {"map":"H0rLfcjDv4","click":"L_VChizvll","container":"N4Il7GGKYs","widget":"Tcs0Ba8AQI"};